/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Card,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { doesSemesterExists, parcoursTypes } from '../../../../helpers/utils';
import groupServices from '../../../../redux/services/groupServices';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import elearningServices from '../../../../redux/services/elearningServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
}));

const getTimeFromSeconds = (time) => {
  if (time === 0) {
    return 'Pas concerné';
  }
  return `${Math.round((time - (time % 60)) / 60)}h${Math.round(time % 60) <= 9 ? '0' : ''}${Math.round(time % 60)}`;
};

const lookupChoices = {
  0: 'Pas concerné',
  50: '50%',
  80: '80%',
  100: '100%',
};

const getGroupsBySemester = (groups, semester) => {
  const res = [];
  for (let i = 0; groups[i]; i += 1) {
    if (groups[i].semester === semester) {
      res.push(groups[i]);
    }
  }
  return res;
};

const Criterias = ({ company, type }) => {
  const [reloadData, setReloadData] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [groups, setGroups] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    groupServices.getGroupByCompanyList(company._id)
      .then((res) => {
        const tmp = [];
        setGroups(res.data);
        for (let i = 0; res.data[i]; i += 1) {
          if (doesSemesterExists({ value: res.data[i].semester }, tmp) === false) {
            tmp.push({
              semester: res.data[i].semester,
              quizPercent: res.data[i].elearning.elearningTarget,
              unitsPercent: res.data[i].elearning.elearningAttempts,
              connexionTime: res.data[i].elearning.elearningDurationTarget,
              elearningDuration: res.data[i].elearning.elearningDuration,
            });
          }
        }
        setTableData(tmp.sort((a, b) => a.semester - b.semester));
      });
  }, [reloadData]);

  const tableref = React.createRef();

  const updateCriteria = (newCriteria) => {
    const _groups = getGroupsBySemester(groups, newCriteria.semester);
    if (_groups.length === 0) {
      toastError('Aucun contenu n\'a été attribué pour ce semestre, veuillez contacter l\'assistance Médical World.');
      return;
    }
    _groups.forEach(async (_group) => {
      const tmpGroup = _group;
      if (newCriteria.elearningDuration <= 100) {
        tmpGroup.elearning.elearningDurationTarget = parseInt(newCriteria.elearningDuration, 10);
      }
      tmpGroup.elearning.elearningTarget = parseInt(newCriteria.quizPercent, 10);
      tmpGroup.elearning.elearningAttempts = parseInt(newCriteria.unitsPercent, 10);
      tmpGroup.elearning.companyId = company._id;
      tmpGroup.elearning.semester = `${newCriteria.semester} level ${_group.level}`;
      await elearningServices.updateElearningDetailsWithNotification(tmpGroup.elearning._id, tmpGroup.elearning);
    });
    toastSuccess('Critères ajoutés.');
    setReloadData(!reloadData);
  };

  return (
    <Card className={classes.root}>
      <MaterialTable
        title={parcoursTypes.includes(type) ? 'Liste des critères' : 'Liste des critères par semestres'}
        columns={parcoursTypes.includes(type)
          ? [
            {
              title: '% de réussite',
              field: 'quizPercent',
              lookup: lookupChoices,
            },
            {
              title: '% Programme',
              field: 'unitsPercent',
              lookup: lookupChoices,
            },
            {
              title: 'Temps de connexion',
              field: 'elearningDuration',
              lookup: lookupChoices,
              render: (rowData) => (rowData.connexionTime === 0
                ? 'Pas concerné'
                : `${getTimeFromSeconds(rowData.elearningDuration * (rowData.connexionTime ? rowData.connexionTime / 100 : 0))} / ${getTimeFromSeconds(rowData.elearningDuration)}`),
            },
          ]
          : [
            {
              title: 'Semestre',
              field: 'semester',
              editable: 'never',
            },
            {
              title: '% de réussite',
              field: 'quizPercent',
              lookup: lookupChoices,
            },
            {
              title: '% Programme',
              field: 'unitsPercent',
              lookup: lookupChoices,
            },
            {
              title: 'Temps de connexion',
              field: 'elearningDuration',
              lookup: lookupChoices,
              render: (rowData) => (!rowData.connexionTime || rowData.connexionTime === 0 ? 'Pas concerné' : `${getTimeFromSeconds(rowData.elearningDuration * (rowData.connexionTime ? rowData.connexionTime / 100 : 0))} / ${getTimeFromSeconds(rowData.elearningDuration)}`),
            },
          ]}
        tableRef={tableref}
        data={tableData}
        style={{
          width: '100%',
          fontSize: '13px',
          color: '#4b4b4b',
        }}
        options={{
          pageSize: 10,
          pageSizeOptions: [5, 10, 20],
        }}
        localization={{
          header: {
            actions: '',
          },
          toolbar: {
            searchPlaceholder: 'Rechercher..',
          },
          body: {
            emptyDataSourceMessage: 'Aucun critère.',
            editRow: {
              deleteText: 'Archiver ces critères ?',
            },
          },
        }}
        editable={{
          onRowUpdate: (newData) => new Promise((resolve) => {
            updateCriteria(newData)
              .then(() => {
                resolve();
              });
          }),
        }}
      />
    </Card>
  );
};

Criterias.propTypes = {
  company: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedSemesters = connect(mapState, null)(Criterias);

export default withRouter(connectedSemesters);
